<ng-container wp-isolated-query-space>
  <op-settings-tab-inner #tabInner></op-settings-tab-inner>
</ng-container>

